// ---- components/About.js ----
export function DukareeAbout() {
  return (
    <section id="about" className="px-6 py-16 max-w-6xl mx-auto">
      <h2 className="text-3xl font-bold text-center mb-1">
        Sales & Distribution Made Smarter
      </h2>
      <p className="text-lg text-gray-700 dark:text-gray-300">
        We empowers your field sales team with real-time tools to capture
        orders, manage stock, and report activities — all while seamlessly
        syncing with your web portal. With custom dashboards, automated reports,
        and analytics-driven insights, Dukaree helps your business reduce admin
        overhead, track team performance, and forecast demand with confidence.
        Designed for African markets, it optimises your sales operations from
        warehouse to outlet, unlocking growth through smarter distribution.
      </p>
    </section>
  );
}
